<template>
    <!--定时器Action No弹出窗-->
    <a-modal
            :title="$t('job.Action')"
            :visible="queryWindow"
            width="80%"
            :maskClosable="false"
            :footer="null"
            :zIndex="99"
            @cancel="cancelQuerySearch">
        <a-row>
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row type="flex" justify="start">
                        <a-col >
                            <a-input size="small" style="width: 150px" v-model="queryCode" @pressEnter="init"/>
                        </a-col>
                        <img class="funcButton" src="../../../assets/img/search.png" width="22" height="22" @click="init" :title="$t('batchReceive.Query')">
                        <img class="funcButton" src="../../../assets/img/refresh2.png" width="22" height="22" @click="reset" :title="$t('pubGicSet.Clear')">
                    </a-row>
                </a-col>
                <a-col style="float: right">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row style="height: 65vh;" class="mt">
                <vxe-table
                        stripe
                        resizable
                        border
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        @cell-dblclick="checked"
                        align="center"
                        height="auto"
                        size="mini"
                        :data="PagingGridList">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column field="uid" title="UID" :visible="false" sortable></vxe-table-column>
                    <vxe-table-column field="jobName" :title="$t('job.Name')" sortable></vxe-table-column>
                    <vxe-table-column field="jobClassName" :title="$t('job.Class')" sortable></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>
    </a-modal>
</template>

<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import XEUtils from "xe-utils";
import cookie from '../../../api/cookie';

export default{
    data(){
        return{
            queryWindow:false,
            pagingTotal: 0, // 总数
            pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),  // 条数
            currentVal: 1, // 当前选中的页数
            PagingGridList: [],//明细列表数据
            pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
            queryCode:'',
        }
    },
    methods:{
        show(data){
            this.queryWindow = true
            this.queryCode = data
            this.init()
        },
        tableChangePage(current) {
            this.currentVal = current;
            this.query();
        },
        onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
            this.currentVal = current;
            this.pagingSize = pageSize;
            this.query();
        },
        cancelQuerySearch(){
            this.queryWindow = false
            this.$emit("checkedCode", null);
        },
        init(){
            this.currentVal = 1;
            this.query();
        },
        query(){
            let params = {//配置查询条件
                currentVal: this.currentVal - 1,
                pagingSize: this.pagingSize,
                jobName: this.queryCode
            }
            ajax.get(api.JOBLIST,params).then(res=>{
                if(res.code == 200){
                    this.PagingGridList = res.data;//列表
                    this.pagingTotal = res.total;//总数
                    if(this.pagingTotal == 1){//如果只有一条数据,自动填充
                        this.selected(this.PagingGridList[0]);
                    }
                }
            })
        },
        reset(){//重置
            this.queryCode = "";
        },
        formatTime ({cellValue}) {
            return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
        },
        checked({ row }) {//双击弹出修改窗口
            this.selected(row);
        },
        selected(row) {//双击弹出修改窗口
            this.queryWindow = false;
            this.$emit("checkedCode", row);
        },
    }
}
</script>

<style scoped>
    .funcButton{
        cursor: pointer;
        margin-left: 5px;
    }
</style>